import React, {useContext, useEffect} from 'react';
import {useSwipeable} from "react-swipeable";
import {AppCtx} from "./AppCtx";

import usePinchZoom from './shared/hooks/usePinchZoom';

const AppWrapper = ({appRef ,children}) => {
  const {
    zooms, setZoom,
    setIsFileBrowserVisible,
    isFullScreen,
    setIsFullScreen,
    setIsTopMenuVisible
  } = useContext(AppCtx);

  usePinchZoom(appRef, zooms, setZoom);

  useEffect(() => {
    const handleFullScreenChange = () => {
      const isCurrentlyFullScreen = document.fullscreenElement !== null;
      setIsFullScreen(isCurrentlyFullScreen);
      setIsTopMenuVisible(!isCurrentlyFullScreen);
    };

    document.addEventListener("fullscreenchange", handleFullScreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullScreenChange);
    document.addEventListener("mozfullscreenchange", handleFullScreenChange);
    document.addEventListener("MSFullscreenChange", handleFullScreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullScreenChange);
      document.removeEventListener("webkitfullscreenchange", handleFullScreenChange);
      document.removeEventListener("mozfullscreenchange", handleFullScreenChange);
      document.removeEventListener("MSFullscreenChange", handleFullScreenChange);
    };
  }, [setIsFullScreen, setIsTopMenuVisible]);

  useEffect(() => {
    const elem = appRef.current;
    if (elem) {
      if (isFullScreen) {
        if (elem.requestFullscreen) {
          elem.requestFullscreen();
        } else if (elem.mozRequestFullScreen) { /* Firefox */
          elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
          elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) { /* IE/Edge */
          elem.msRequestFullscreen();
        }
      } else {
        // Check if we're actually in fullscreen before trying to exit
        const isCurrentlyFullscreen = document.fullscreenElement ||
                                    document.webkitFullscreenElement ||
                                    document.mozFullScreenElement ||
                                    document.msFullscreenElement;

        if (!isCurrentlyFullscreen) {
          return;
        }

        if (document.exitFullscreen) {
          document.exitFullscreen().catch((err) => {
            console.error('Failed to exit fullscreen:', err);
          });
        } else if (document.mozCancelFullScreen) { /* Firefox */
          document.mozCancelFullScreen().catch((err) => {
            console.error('Failed to exit fullscreen:', err);
          });
        } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
          document.webkitExitFullscreen().catch((err) => {
            console.error('Failed to exit fullscreen:', err);
          });
        } else if (document.msExitFullscreen) { /* IE/Edge */
          document.msExitFullscreen().catch((err) => {
            console.error('Failed to exit fullscreen:', err);
          });
        }
      }
    } else {
      console.error('Element not found');
    }
  }, [isFullScreen, appRef]);

  const swipeHandlers = useSwipeable({
    onSwipedLeft: (eventData) => {
      if (eventData.absY < 30 && eventData.absX > 70) {
        setIsFileBrowserVisible(false);
      }
    },
    onSwipedRight: (eventData) => {
      if (eventData.initial[0] < 50 && eventData.absY < 30 && eventData.absX > 70) {
        setIsFileBrowserVisible(true);
      }
    },
    preventDefaultTouchmoveEvent: true,
    trackMouse: false,
  });

  return (
    <div {...swipeHandlers} style={{display: 'flex', width: '100%'}}>
      {children}
    </div>
  );
};

export default AppWrapper;
